const AUTH_REDIRECT_ERRORS = new Set(["consent_required", "login_required"]);

let consentRedirectStarted = false;

export const isCubeConsentRedirectStarted = () => consentRedirectStarted;

export const markCubeConsentRedirectStarted = () => {
  consentRedirectStarted = true;
};

export const resetCubeConsentRedirectForTests = () => {
  consentRedirectStarted = false;
};

export const isAuthRedirectError = (error: string | undefined) =>
  error !== undefined && AUTH_REDIRECT_ERRORS.has(error);
